module.exports = __webpack_public_path__ + "static/media/fourplex_blue.235023e9.svg";